export const formatNames = (names: string[]) => {
  if (names.length <= 1) {
    return names.join('')
  }

  const lastName = names[names.length - 1]
  const otherNames = names.slice(0, -1)

  return `${otherNames.join(', ')} & ${lastName}`
}
